import { render, staticRenderFns } from "./JLjhHour.vue?vue&type=template&id=804d8cd2&scoped=true"
import script from "./JLjhHour.vue?vue&type=script&lang=js"
export * from "./JLjhHour.vue?vue&type=script&lang=js"
import style0 from "./JLjhHour.vue?vue&type=style&index=0&id=804d8cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804d8cd2",
  null
  
)

export default component.exports